import React, { useContext, useEffect } from "react";
import "./App.css";
import "./index.css";
import ".";
import  { LoadingModal } from "./utils/context/loading";
import { RootState } from "./utils/redux/store";
import { useAppSelector } from "./utils/redux/hooks";
import NewIndex from "./pages/config";

import { ToastContainer, toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
function App() {
  const [loading, ] = React.useState(
    useContext(LoadingModal).initState
  );
  console.log(loading);
  const isLoading = useAppSelector((store:RootState) => store.user.isLoading);

  // useEffect(() => {
  //   // Define the function to fetch data
  //   const fetchData = () => {
  //     fetch('https://pureworker-api.onrender.com/api')
  //       .then(response => response.json())
  //       .then(data => {
  //         // Process the data here
  //         console.log('Data:', data);
  //       })
  //       .catch(error => {
  //         console.error('Error fetching data:', error);
  //       });
  //   };

  //   // Call fetchData initially
  //   fetchData();

  //   // Set up an interval to call fetchData every 30 seconds
  //   const fetchDataInterval = setInterval(fetchData, 30000);

  //   // Clear the interval when the component is unmounted
  //   return () => clearInterval(fetchDataInterval);
  // }, []);
  
  
  return (
    <div>
      {/* <LoginForm /> */}
      {/* <LoadingModalProvider>
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/Dashboard/:id" element={<Index />} />
          <Route path="/index" element={<Index />} />
          <Route path="/wallet/customer" element={<WalletCustomer/>} />
        </Routes>
      </LoadingModalProvider> */}

      <NewIndex/>
      <ToastContainer />
      {/* {isLoading && (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      )} */}
    </div>
  );
}
export default App;
